const INTRO_CONFIG = {
  active: false,
  sceneBlur: 6,
}

export { INTRO_CONFIG };
